import {useState, useEffect} from 'react'
import {getPaginationRange} from '../../../../../../../Utils/commonPagination'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponsePagination, useQueryResponseLoading} from '../../core/QueryResponseProvider'

const ListPagination = () => {
  const options = [
    {value: 10, label: '10'},
    {value: 50, label: '50'},
    {value: 100, label: '100'},
  ]
  const pagination = useQueryResponsePagination()
  const isLoading = useQueryResponseLoading()
  const {updateState} = useQueryRequest()
  
  const updatePage = (page: number | null) => {
    if (!page || isLoading || pagination.page === page) {
      return
    }

    updateState({page, items_per_page: pagination.items_per_page || 10})
  }

  // Set default value to the option with label '10'
  const [option1, setOption1] = useState(options[0])
  // Handle changes to the selected option
  const handleChange = (selectedOption: any) => {
    setOption1(selectedOption)
    if (selectedOption !== null && selectedOption !== undefined && selectedOption.value) {
      updateState({items_per_page: selectedOption.value})
    }
  }

  useEffect(() => {
    if (pagination.page !== 1) {
      updateState({page: 1})
    }
  }, [option1])

  return (
    <div className='row'>
      <div
        className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'
      >
        <div className='dataTables_length' id='kt_table_multiple_ivr_length'>
          <label>
            <select
              name='kt_table_multiple_ivr_length'
              aria-controls='kt_table_multiple_ivr'
              className='form-select form-select-sm form-select-solid'
              value={option1.value}
              onChange={(e) => {
                const selectedOption = options.find(opt => opt.value === parseInt(e.target.value))
                if (selectedOption) {
                  handleChange(selectedOption)
                }
              }}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className='dataTables_info' id='kt_table_multiple_ivr_info' role='status' aria-live='polite'>
          {(() => {
            const range = getPaginationRange(pagination.from, pagination.to, pagination.total)
            return `Showing ${range.from} to ${range.to} of ${range.total} entries`
          })()}
        </div>
      </div>
      <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
        <div className='dataTables_paginate paging_simple_numbers' id='kt_table_multiple_ivr_paginate'>
          <ul className='pagination'>
            <li className={`paginate_button page-item previous ${pagination.page === 1 ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => updatePage(pagination.page - 1)}
                disabled={pagination.page === 1}
              >
                <i className='previous'></i>
              </button>
            </li>
            <li className='paginate_button page-item active'>
              <button className='page-link'>{pagination.page}</button>
            </li>
            <li className={`paginate_button page-item next ${pagination.page === pagination.last_page ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => updatePage(pagination.page + 1)}
                disabled={pagination.page === pagination.last_page}
              >
                <i className='next'></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export {ListPagination}

